import { X } from '@phosphor-icons/react';
import { COLORS } from 'assets/styled';
import Icon from 'components/Icon/Icon';
import {
  AbsoluteClearWrapper,
  InlineClearWrapper,
} from './ClearValueButton.styled';

interface IClearValueButtonProps {
  onClear: () => void;
  // Radio groups have no field box to sit inside, so their button renders in
  // the flow at the end of the options instead of pinned to a field.
  inline?: boolean;
  // Distance from the field's right edge — for an inline button, from the
  // right edge of the row it ends. Leave room for the field's own indicator:
  // the number spinner sits on the right.
  right?: string;
  controlHeight?: string;
  // Textareas are too tall to centre against, so the button hugs the top.
  alignTop?: boolean;
  // Centre on a control whose height is set by its content instead of on a
  // known control height.
  alignCenter?: boolean;
  // Render the button's space without the button. The markup is identical to
  // the visible one down to the ripple, so the control keeps the exact same
  // geometry whether or not the question has a value yet.
  hidden?: boolean;
  pwId?: string;
}

const ClearValueButton = ({
  onClear,
  inline = false,
  right = '10rem',
  controlHeight = '40rem',
  alignTop = false,
  alignCenter = false,
  hidden = false,
  pwId,
}: IClearValueButtonProps) => {
  const icon = (
    <Icon
      tabIndex={'-1'}
      svg={X}
      weight={'bold'}
      size={16}
      color={COLORS.RED_100}
      // Kept on the hidden button too: without a click handler Icon drops the
      // ripple wrapper around the svg, and the reserved space would be narrower
      // than the button it stands in for.
      onClick={onClear}
    />
  );

  return inline ? (
    <InlineClearWrapper
      data-testid={hidden ? undefined : pwId}
      right={right}
      isHidden={hidden}
      aria-hidden={hidden || undefined}
    >
      {icon}
    </InlineClearWrapper>
  ) : (
    <AbsoluteClearWrapper
      data-testid={hidden ? undefined : pwId}
      right={right}
      controlHeight={controlHeight}
      alignTop={alignTop}
      alignCenter={alignCenter}
      isHidden={hidden}
      aria-hidden={hidden || undefined}
    >
      {icon}
    </AbsoluteClearWrapper>
  );
};

export default ClearValueButton;
